// FileService.ts
import Avatar from "../../interfaces/avatar/Avatar";
import {
  DriveCache,
  DriveItem,
  Participant,
} from "../../interfaces/caseFileDrive/DriveFiles";
import DriveFile from "../../interfaces/file/DriveFile";
import DriveFiles from "../../interfaces/file/DriveFiles";
import DriveFilesByEmployee from "../../interfaces/file/DriveFilesByEmployee";
import {
  CaseFileMetadataRes,
  GetSharedCaseFilesReq,
  GetSharedFileResponseDto,
  SheredCaseFileRes,
} from "../../interfaces/file/file";
import {
  GetFolderRequest,
  GetFolderResponse,
} from "../../interfaces/file/UserFiles";
import NewTemplateFile from "../../interfaces/task/TaskFiles/NewTemplateFile";
import TemplateFile from "../../interfaces/task/TaskFiles/TemplateFile";
import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";
import { UserFileMetadata } from "../../interfaces/userDrive/userFile";

// Function to fetch all participants of an employee
export async function uploadFile(
  file: File,
  taskId: string,
  mimeType: string,
  fileSize: number,
  authToken: string
): Promise<boolean | null> {
  try {
    const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/upload`;

    // We are not using participant ID here, that's now handled by the API; value overwritten
    const orgId: string = "1";
    const regionId: string = "2";
    const participantId: string = "2";
    const typeId: string = "1";

    const formData = new FormData();
    formData.append("file.File", file);
    formData.append("file.OrganizationId", orgId);
    formData.append("file.RegionId", regionId);
    formData.append("file.participantId", participantId);
    formData.append("file.TypeId", typeId);
    formData.append("file.Taskid", taskId);
    formData.append("file.MimeType", mimeType);
    formData.append("file.Size", fileSize.toString());

    const response = await fetch(apiUrl, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (response.ok) {
      return true;
      // Handle success
    } else {
      // Handle failure
      console.error("Upload failed");
      // Print out the response body if available
      const responseBody = await response.json().catch((parseError) => {
        console.error("Error parsing JSON:", parseError);
      });
      console.log("Error Response Body:", responseBody);
      return false;
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    // Handle error
    return false;
  }
}

export async function uploadFileInPlace(
  file: File,
  taskId: string,
  attachmentId: number,
  mimeType: string,
  fileSize: number,
  authToken: string
): Promise<boolean | null> {
  try {
    const apiUrl: string = `${
      process.env.REACT_APP_API_BASE_URL
    }/file/upload/${attachmentId.toString()}`;

    // We are not using participant ID here, that's now handled by the API; value overwritten
    const orgId: string = "1";
    const regionId: string = "2";
    const participantId: string = "2";
    const typeId: string = "1";

    const formData = new FormData();
    formData.append("file.File", file);
    formData.append("file.OrganizationId", orgId);
    formData.append("file.RegionId", regionId);
    formData.append("file.participantId", participantId);
    formData.append("file.TypeId", typeId);
    formData.append("file.Taskid", taskId);
    formData.append("file.MimeType", mimeType);
    formData.append("file.Size", fileSize.toString());

    const response = await fetch(apiUrl, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (response.ok) {
      return true;
      // Handle success
    } else {
      // Handle failure
      console.error("Upload failed");
      // Print out the response body if available
      const responseBody = await response.json().catch((parseError) => {
        console.error("Error parsing JSON:", parseError);
      });
      console.log("Error Response Body:", responseBody);
      return false;
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    // Handle error
    return false;
  }
}

// Function to fetch all participants of an employee
// We are not using participant ID here, that's now handled by the API; value overwritten
export async function uploadRequiredFile(
  file: File,
  taskId: string,
  //   attachment: TaskRequiresAttachment,
  durationInMinutes: string,
  mimeType: string,
  fileSize: number,
  authToken: string,
  RequiredAttachmentId: number | null,
  fileName: string
): Promise<boolean | null> {
  try {
    const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/upload`;

    const orgId: string = "1";
    const regionId: string = "2";
    const participantId: string = "2";
    const typeId: string = "1";

    const formData = new FormData();
    formData.append("file.File", file);
    // formData.append("file.FileName", attachment.templateFile.fileName);
    formData.append("file.FileName", fileName);
    formData.append("file.DurationInMinutes", durationInMinutes);
    // formData.append("file.RequiredAttachmentId", attachment.id.toString());
    if (RequiredAttachmentId !== null) {
      formData.append(
        "file.RequiredAttachmentId",
        RequiredAttachmentId.toString()
      );
    }
    formData.append("file.OrganizationId", orgId);
    formData.append("file.RegionId", regionId);
    formData.append("file.participantId", participantId);
    formData.append("file.TypeId", typeId);
    formData.append("file.Taskid", taskId);
    formData.append("file.MimeType", mimeType);
    formData.append("file.Size", fileSize.toString());

    const response = await fetch(apiUrl, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (response.ok) {
      return true;
      // Handle success
    } else {
      console.error("Upload failed");
      return false;
      // Handle failure
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    // Handle error
    return false;
  }
}

export async function getDriveFilesByUser(
  authToken: string
): Promise<DriveFiles | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/drive`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const data: DriveFiles = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching files:", err);
    return null;
  }
}

export async function getDriveAllFiles(
  authToken: string
): Promise<DriveFilesByEmployee | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/drive/all`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const data: DriveFilesByEmployee = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching files:", err);
    return null;
  }
}

export async function getEmployeeDriveFiles(
  authToken: string,
  userId: string
): Promise<DriveFilesByEmployee | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/drive/employee/${userId}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const data: DriveFilesByEmployee = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching files:", err);
    return null;
  }
}

export async function getDriveFileById(
  id: string,
  authToken: string
): Promise<DriveFile | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/metadata/${id}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const status = response.status;
    console.log(status);
    const data = await response.json();
    console.log(data);
    return data;
  } catch (err) {
    console.error("Error fetching files:", err);
    return null;
  }
}

export async function getFileById(
  id: string,
  authToken: string
): Promise<string | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/download/${id}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const blob = await response.blob();

    return URL.createObjectURL(blob);
  } catch (err) {
    console.error("Error fetching files:", err);
    return null;
  }
}

export async function getFileByIdByToken(
  authToken: string
): Promise<string | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/public/${authToken}/file`;

  console.log("Calling getFileByIdByToken");
  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const blob = await response.blob();

    return URL.createObjectURL(blob);
  } catch (err) {
    console.error("Error fetching files:", err);
    return null;
  }
}

export async function fetchAndStoreAvatars(authToken: string): Promise<void> {
  const AvatarRefreshInterval = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  const storedData = localStorage.getItem("userAvatar");

  if (storedData) {
    const { timestamp } = JSON.parse(storedData);
    const currentTime = new Date().getTime();
    const timeElapsed = currentTime - timestamp;

    if (timeElapsed < AvatarRefreshInterval) {
      // Avatars are still fresh, no need to fetch again
      return;
    }
  }

  // Proceed to fetch new avatars if no data or data is outdated
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/avatar`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (!response.ok) {
      console.error("Error fetching avatars:", response.statusText);
      return;
    }

    const avatarsList: Avatar[] = await response.json();

    // Store the avatars with the current timestamp in localStorage
    const dataWithTimestamp = {
      timestamp: new Date().getTime(),
      avatars: avatarsList,
    };

    localStorage.setItem("userAvatars", JSON.stringify(dataWithTimestamp));
  } catch (err) {
    console.error("Error fetching avatars:", err);
  }
}

export function getAvatarsFromStorage(): Avatar[] | null {
  const storedData = localStorage.getItem("userAvatars");

  if (!storedData) {
    return null; // No data in storage, need to fetch
  }

  const { avatars }: { avatars: Avatar[] } = JSON.parse(storedData);

  return avatars;
}

export async function uploadAvatar(
  authToken: string,
  uid: string,
  file: File
): Promise<string> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/upload/avatar`;

  const formData = new FormData();
  formData.append("file", file); // Ensure the key matches what your API expects

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (response.ok) {
      const fileLocation = await response.text(); // Parse the response as a plain string

      // Retrieve existing avatars from localStorage
      const storedAvatars = JSON.parse(
        localStorage.getItem("userAvatars") || "[]"
      ).avatars;

      // Update the storedAvatars array with the new avatar
      const updatedAvatars = storedAvatars.filter(
        (avatar: any) => avatar.id !== uid
      );
      updatedAvatars.push({ id: uid, avatar: fileLocation });

      // Save the updated avatars list back to localStorage
      localStorage.setItem("userAvatars", JSON.stringify(updatedAvatars));

      return fileLocation;
    } else {
      // Handle failure
      console.error("Upload failed");
      const responseBody = await response.text();
      console.log("Error Response Body:", responseBody);
      return "Error";
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    return "Error";
  }
}

export async function deleteFileById(
  id: string,
  authToken: string
): Promise<boolean | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/delete/${id}`;

  try {
    const response = await fetch(apiUrl, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (response.ok) {
      return true;
    } else {
      console.error(`Delete failed with status: ${response.status}`);
      const errorText = await response.text().catch(() => "Unknown error");
      console.error("Error Response:", errorText);
      return false;
    }
  } catch (err) {
    console.error("Error deleting file:", err);
    return null;
  }
}

export async function downloadFile(
  id: string,
  authToken: string
): Promise<Blob | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/download/${id}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (!response.ok) {
      console.error(`Unable to fetch file ${id} for download`);
      return null;
    }

    return response.blob();
  } catch (err) {
    console.error("Error deleting file:", err);
    return null;
  }
}

export async function getTemplateFiles(
  authToken: string
): Promise<TemplateFile[] | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/templateFiles`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const data = await response.json();
    var res: TemplateFile[] = data.map((d: any) => ({
      id: d.id,
      fileName: d.fileName,
      type: d.type,
      formId: d.form?.id,
      estimatedTtc: d.estimatedTTC,
    }));
    return res;
  } catch (err) {
    console.error("Error fetching files:", err);
    return null;
  }
}

export async function updateFileTemplate(
  templateFile: TemplateFile,
  authToken: string
): Promise<ApiResponse<TemplateFile>> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/templateFile`;

  try {
    // Converet NewTask type to TaskRequest type
    const requestBody = {
      id: templateFile.id,
      fileName: templateFile.fileName,
      type: templateFile.type,
      formId: templateFile.formId,
      estimatedTtc: templateFile.estimatedTtc,
    };

    console.log("Request Body: ", requestBody);

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      return await response.json();
    } catch (error) {
      console.log("Error posting activity", error);
      throw error;
    }
  } catch (err) {
    console.error("Error fetching files:", err);
    throw err;
  }
}

export async function publishTemplateFile(
  templateFile: NewTemplateFile,
  authToken: string
): Promise<ApiResponse<number>> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/templateFile`;

  try {
    const formId = templateFile.formId;
    const typeId = templateFile.typeId;
    // Converet NewTask type to TaskRequest type
    const requestBody = {
      fileName: templateFile.fileName,
      formId: formId === "" || formId === undefined ? null : parseInt(formId),
      typeId: typeId === undefined || typeId === "" ? null : parseInt(typeId),
    };

    console.log("Request Body: ", requestBody);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      return response.json();
    } catch (error) {
      console.log("Error posting activity", error);
      throw error;
    }
  } catch (err) {
    console.error("Error fetching files:", err);
    throw err;
  }
}

export async function getCanUserDeleteTaskFile(
  authToken: string,
  taskId: string
): Promise<boolean> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/canDeleteTaskFiles/${taskId}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const data = await response.ok;
    return data;
  } catch (err) {
    console.error("Error fetching files:", err);
    return false;
  }
}

export async function getDriveData(
  authToken: string,
  employeeId?: string
): Promise<Participant[]> {
  // 1. Check localStorage for cached data

  const STORAGE_KEY = `driveData${employeeId ? "_" + employeeId : ""}`;
  const EXPIRY_MS = 2 * 60 * 1000; // 2 minutes

  const cachedString = localStorage.getItem(STORAGE_KEY);
  if (cachedString) {
    const cached: DriveCache = JSON.parse(cachedString);
    if (Date.now() < cached.expiry) {
      // Not expired
      return cached.data;
    }
  }

  // 2. If no cache or expired, fetch from server
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/grouped${
    employeeId ? "/" + employeeId : ""
  }`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch drive data");
  }
  const data: Participant[] = await response.json();

  // 3. Store in localStorage with new expiry
  const newCache: DriveCache = {
    data,
    expiry: Date.now() + EXPIRY_MS,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(newCache));

  return data;
}

export async function getUserFolderDataAsDriveItems(
  token: string,
  folderId: string | null,
  pageNumber: number,
  pageSize: number
): Promise<{
  currentFolder?: any;
  items: DriveItem[];
  count: number;
}> {
  const payload: GetFolderRequest = {
    folderId: folderId,
    pageNumber: pageNumber,
    pageSize: pageSize,
  };
  const { currentFolder, folders, files, count } = await getUserFolderData(
    token,
    payload
  );

  // Map folders to DriveItem
  const folderItems: DriveItem[] = folders.map((f) => ({
    id: f.id.toString(),
    name: f.name,
    isFolder: true,
    size: f.size,
    createdAt: f.createdAt,
    updateDate: f.lastUpdatedDate || f.updateDate || f.createdAt,
    lastUpdatedDate: f.lastUpdatedDate || f.updateDate,
    // optionally store additional data in custom fields
  }));

  // Map files to DriveItem
  const fileItems: DriveItem[] = files.map((fi) => ({
    id: fi.id.toString(),
    name: fi.name,
    isFolder: false,
    size: fi.size,
    mimeType: fi.mimeType,
    updateDate: fi.createdAt,
    authorFullName: fi.authorFullName,
    authorId: fi.authorId,
    sharedWithUsers: fi.sharedWithUsers,
    createdAt: fi.createdAt,
    // etc.
  }));

  return {
    currentFolder,
    items: [...folderItems, ...fileItems],
    count,
  };
}

// Example: getUserFolderData(token, folderId) -> return DriveItem[]

export async function getUserFolderData(
  token: string,
  payload: GetFolderRequest
): Promise<GetFolderResponse> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/userDrive`;
  // The API would return a structure with subFolders and files
  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error("Error fetching folder data");

  const data = (await response.json()) as GetFolderResponse;

  return data;
}

export async function uploadAndShareFile(
  authToken: string,
  file: File,
  sharedByUserId: string,
  sharedWithUserIds: string[],
  fileType: string
): Promise<ApiResponse<any>> {
  const formData = new FormData();
  formData.append("File", file);
  formData.append("SharedByUserId", sharedByUserId);
  sharedWithUserIds.forEach((id) => {
    formData.append("SharedWithUserIds", id); // ✅ Correct for .NET List<string>
  });
  formData.append("FileType", fileType);

  const response = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/employee/upload-and-share`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      body: formData,
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    console.error("Failed to upload and share file:", errorText);
    throw new Error(errorText);
  }

  return await response.json();
}

export const GetSharedCaseFilesAsync = async (
  authToken: string,
  viewedUserId: string,
  pageNumber: number = 1,
  pageSize: number = 100
): Promise<ApiResponse<GetSharedFileResponseDto>> => {
  try {
    const payload: GetSharedCaseFilesReq = {
      viewedUserId: viewedUserId,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/employee/shared-case-files`;
    // Adjust the base URL if needed
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export async function getCaseFileMetadataAsync(
  id: string,
  authToken: string
): Promise<CaseFileMetadataRes> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/casefile/download/${id}/metadata`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const data: CaseFileMetadataRes = await response.json();
    return data;
  } catch (err) {
    throw err;
  }
}

export async function getCaseFileByIdAsync(
  id: string,
  authToken: string
): Promise<string | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/casefile/download/${id}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (err) {
    console.error("Error fetching files:", err);
    return null;
  }
}

export const GetSharedUserFilesAsync = async (
  authToken: string,
  viewedUserId: string,
  PageNumber: number = 1,
  pageSize: number = 100
): Promise<ApiResponse<GetSharedFileResponseDto>> => {
  try {
    const payload = {
      PageNumber: PageNumber,
      PageSize: pageSize,
    };
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/employee/user/${viewedUserId}/shared/userfile`;
    // Adjust the base URL if needed
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    return await response.json();
  } catch (error) {
    throw error;
  }
};

// this function is used to get the metadata of a user file by its ID
// Its use for all the table but you need to update it in backend to return the metadata of the file
export async function GetFileMetadataAsync(
  fileId: string,
  fileTable: string,
  authToken: string
): Promise<UserFileMetadata | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/download/${fileTable}/${fileId}/metadata`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const data: UserFileMetadata = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching files:", err);
    return null;
  }
}

// this fuction is used in ViewFile.tsx to get the file by its ID
export async function getFileDownloadByIdAsync(
  fileId: string,
  tableType: string,
  authToken: string
): Promise<string | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/download/${tableType}/${fileId}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (err) {
    console.error("Error fetching files:", err);
    return null;
  }
}

// this fuction is ued for only PDF files in UserFilePDFViewer.tsx
export async function getFileByIdForPDFAsync(
  fileId: string,
  tableType: string,
  authToken: string
): Promise<string | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/download/forpdf/${tableType}/${fileId}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (err) {
    console.error("Error fetching files:", err);
    return null;
  }
}

export async function GetDownlodablefileByfileLocationAsync(
  fileLocation: string,
  authToken: string
): Promise<string | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/download/filelocation`;
  const payload = {
    filelocation: fileLocation,
  };
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const blob = await response.blob();
    console.log("Blobbb : ", blob);

    return URL.createObjectURL(blob);
  } catch (err) {
    console.error("Error fetching files:", err);
    return null;
  }
}

export async function SharedDriveExistingFlle(
  fileId: string,
  authToken: string,
  sharedByUserId: string,
  sharedWithUserIds: string[]
): Promise<ApiResponse<any>> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/employee/share-existing-file`;
  const payload = {
    fileId: fileId,
    sharedByUserId: sharedByUserId,
    sharedWithUserIds: sharedWithUserIds,
  };
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
}
export interface CreateFileRequestDto {
  taskId: number;
  employeeId: string;
  participantId: number;
  templateTypeIds: number[];
  comment: string;
}

export async function createParticipantFileRequest(
  authToken: string,
  payload: CreateFileRequestDto
): Promise<any> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/participant-file-requests`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (err) {
    console.error("Error creating file request:", err);
    return null;
  }
}

export async function UnshareFileAsync(
  authToken: string,
  fileSharedWithUserId: string // this is the shared table id
): Promise<ApiResponse<boolean>> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/file/delete/${fileSharedWithUserId}/unshare-file`;

  try {
    const response = await fetch(apiUrl, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
}

export async function deleteFileByIdFromReciverSide(
  fileid: string,
  authToken: string
): Promise<ApiResponse<boolean>> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/employee/delete/formReceiver/${fileid}`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    return await response.json();
  } catch (err) {
    throw err;
  }
}
